export default {
  wrapper: {
    base: {
      bg: 'grey-10',
      variant: 'spark.base.wrapper'
    }
  },
  bar: {
    base: {
      bg: 'blue'
    }
  }
};